import { useState } from 'react';

// A row type with none of these ids joins to '||||' and never resets.
const getRowIdentity = (row: any): string | null =>
    row ? [row.dealId, row.parentDealId, row.assesseeOrgId, row.id, row._isCollapsibleRow].join('|') : null;

// A key that changes only when a different real row replaces another; the first row arriving after
// loading (null -> row) adopts the key, so what the user typed meanwhile survives.
export function useRowIdentityKey(row: any): number {
    const identity = getRowIdentity(row);
    const [tracked, setTracked] = useState({ identity, key: 0 });

    // Adjusting state during render: React re-renders at once, so no frame shows the new row with the old key.
    if (identity !== null && identity !== tracked.identity) {
        setTracked({ identity, key: tracked.identity === null ? tracked.key : tracked.key + 1 });
    }

    return tracked.key;
}
